import { Text, Table, Card, Button, LoadingOverlay, Loader } from '@mantine/core';
import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Layout from '../../Layout/Layout';
import { useDispatch, useSelector } from 'react-redux';
import { getCustomers } from '../../actions/customerActions';
import moment from 'moment';


const Customers = ({ title }) => {

    const dispatch = useDispatch();
    const { loading: customersLoading, customers } = useSelector((state) => state.customers);

    useEffect(() => {
        dispatch(getCustomers())
    }, [dispatch])

    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <title>{title}</title>
            </Helmet>
            <Layout activeKey={5}>
                <Card radius='md' shadow='xl'>
                    <span style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', margin: '10px' }}>
                        <Text weight={700} size='xl'>Customers</Text>
                    </span>
                    {customersLoading ? <LoadingOverlay visible={customersLoading} loader={<Loader color='orange' />} /> : <Table highlightOnHover>
                        <thead>
                            <tr>
                                <th>Firstname</th>
                                <th>Lastname</th>
                                <th>Contact</th>
                                <th>NIC</th>
                                <th>Email</th>
                                <th>Address</th>
                                <th>DOB</th>
                                <th>Joined</th>
                                <th>Updated</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {customers && customers.map((customer, key) => {
                                return <tr key={key}>
                                    <td>{customer.firstname}</td>
                                    <td>{customer.lastname}</td>
                                    <td>{customer.contact}</td>
                                    <td>{customer.nic}</td>
                                    <td>{customer.email}</td>
                                    <td>{customer.houseNo}, {customer.streetAddress}, {customer.streetAddress2 && customer.streetAddress2 + ', '} {customer.city}</td>
                                    <td>{moment(customer.dob).format('DD-MMM-YYYY')}</td>
                                    <td>{moment(customer.createdAt).format('DD-MMM-YYYY')}</td>
                                    <td>{moment(customer.updatedAt).format('DD-MMM-YYYY')}</td>
                                    <td>
                                        <Button color='blue' variant='light' radius='md' fullWidth>
                                            Edit
                                        </Button>
                                    </td>
                                </tr>
                            })}


                        </tbody>
                    </Table>
                    }




                </Card>
            </Layout>

        </>

    )
}

export default Customers
